<template>
  <div id="PurchaseContractMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">创建日期</span>
            <el-date-picker v-model="createDate" size="small" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" class="filter-date"></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">店铺</span>
            <el-select v-model="params.shopName" size="small" filterable clearable placeholder="全部">
              <el-option v-for="item in shopOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">供应商</span>
            <el-select v-model="params.supplierId" size="small" filterable clearable placeholder="全部">
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">业务类型</span>
            <el-select v-model="params.sourceType" size="small" clearable placeholder="全部">
              <el-option v-for="item in sourceTypeOptions" :key="item.value || 'all'" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">合同编号</span>
            <el-input v-model="params.contractNo" size="small" clearable placeholder="请输入合同编号"></el-input>
            <el-button type="primary" size="small" icon="el-icon-search" class="query-btn" @click="queryBtn">查询</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label" class="status-tab-label">
            {{ tab.label }}
            <el-badge v-if="tab.showBadge && statusCounts[tab.name] > 0" :value="statusCounts[tab.name]" class="status-tab-badge"></el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="table-container">
        <el-table :data="tableData" border stripe size="mini" :height="screenHeight" v-loading="loading" element-loading-text="加载中..." :span-method="spanMethod" cell-class-name="contractTableCellClassName" header-cell-class-name="table-header-cell" class="mgmt-table">
          <el-table-column label="序号" width="52" align="center" fixed="left">
            <template slot-scope="scope">
              <span v-if="scope.row._contractRowSpan > 0">{{ getContractRowIndex(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractNo" label="合同编号" width="150" show-overflow-tooltip class-name="merge-col"></el-table-column>
          <el-table-column prop="shopName" label="店铺" width="56" align="center" show-overflow-tooltip class-name="merge-col"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="120" show-overflow-tooltip class-name="merge-col"></el-table-column>
          <el-table-column prop="sourceType" label="业务类型" width="72" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.sourceTypeLabel || scope.row.sourceType" size="mini" :type="getSourceTypeTagType(scope.row.sourceType)" effect="plain">
                {{ scope.row.sourceTypeLabel || getSourceTypeLabel(scope.row.sourceType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="contractStatus" label="合同状态" width="120" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.contractStatusLabel" size="mini" :type="getContractStatusType(scope.row.contractStatus)" effect="light">
                {{ scope.row.contractStatusLabel }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="180" show-overflow-tooltip class-name="text-col-20"></el-table-column>
          <el-table-column prop="specModel" label="规格型号" width="220" show-overflow-tooltip class-name="text-col-20"></el-table-column>
          <!-- <el-table-column prop="unit" label="单位" width="40" align="center">
            <template slot-scope="scope">{{ scope.row.unit || "个" }}</template>
          </el-table-column> -->
          <el-table-column prop="quantity" label="数量" width="55" align="right"></el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="60" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="80" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.amount) }}</template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" width="50" align="right">
            <template slot-scope="scope">{{ formatTaxRate(scope.row.taxRate) }}</template>
          </el-table-column>
          <el-table-column prop="taxAmount" label="税额" width="60" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.taxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalAmount" label="金额合计" width="80" align="right" class-name="merge-col">
            <template slot-scope="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalTaxAmount" label="税费合计" width="80" align="right" class-name="merge-col">
            <template slot-scope="scope">{{ formatMoney(scope.row.totalTaxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalWithTax" label="价税合计" width="80" align="right" class-name="merge-col highlight-amount">
            <template slot-scope="scope">
              <span class="money-text">{{ formatMoney(scope.row.totalWithTax) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractDate" label="合同日期" width="85" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="contractFileUrls" label="合同" width="80" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="scope.row._contractImageUrls.length" class="contract-file-thumbs">
                <el-image
                  v-for="(url, index) in scope.row._contractImageUrls.slice(0, 3)"
                  :key="url + '-' + index"
                  :src="url"
                  :preview-src-list="scope.row._contractImageUrls"
                  fit="cover"
                  class="contract-file-thumb"
                ></el-image>
                <span v-if="scope.row._contractImageUrls.length > 3" class="contract-file-more">+{{ scope.row._contractImageUrls.length - 3 }}</span>
              </div>
              <el-button
                v-else-if="scope.row._contractFileItems.length"
                type="text"
                size="small"
                class="contract-file-link"
                @click="onPreviewContractFile(scope.row)"
              >
                {{ getContractFileDisplayName(scope.row) }}
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="96" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div class="row-item">{{ formatCreateDate(scope.row.createTime) }}</div>
              <div class="row-item row-sub">{{ formatCreateTimePart(scope.row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="scope.row.remark || scope.row.rejectReason" class="remark-cell">
                <div v-if="scope.row.remark">{{ scope.row.remark }}</div>
                <div v-if="scope.row.rejectReason" class="reject-reason-text">打回原因：{{ scope.row.rejectReason }}</div>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right" class-name="action-col">
            <template slot-scope="scope">
              <div v-if="scope.row._contractRowSpan > 0" class="action-cell">
                <el-button
                  v-for="action in getVisibleContractActions(scope.row)"
                  :key="action.key"
                  type="text"
                  size="small"
                  :class="['action-btn', action.btnClass]"
                  @click="handleContractRowAction(action.key, scope.row)"
                >
                  {{ action.label }}
                </el-button>
                <el-dropdown v-if="getMoreContractActions(scope.row).length" trigger="click" @command="cmd => handleContractRowAction(cmd, scope.row)">
                  <el-button type="text" size="small" class="action-btn">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="contract-action-dropdown">
                    <el-dropdown-item v-for="action in getMoreContractActions(scope.row)" :key="action.key" :command="action.key" :class="action.btnClass">
                      {{ action.label }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-box">
        <el-pagination layout="prev, pager, next, total" background :page-size="params.pageSize" :total="total" :current-page="currentPage" @current-change="handlerPageChange"></el-pagination>
      </div>
    </div>

    <el-dialog title="打回" :visible.sync="rejectDialogVisible" width="480px" custom-class="pay-order-reject-dialog" :close-on-click-modal="false">
      <div class="reject-dialog-tip">确认打回到「{{ rejectTargetStatus }}」</div>
      <el-input v-model="rejectReason" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入打回原因"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRejectContract" :loading="rejectSubmitting">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="关联发票" :visible.sync="invoiceDialogVisible" width="80%" top="8vh" custom-class="contract-invoice-dialog" :close-on-click-modal="false">
      <div class="contract-invoice-table-wrap">
        <el-table
          :data="invoiceTableData"
          border
          stripe
          size="mini"
          max-height="420"
          v-loading="invoiceDialogLoading"
          empty-text="暂无关联发票"
          :span-method="invoiceDialogSpanMethod"
          :cell-class-name="invoiceDialogCellClassName"
          header-cell-class-name="table-header-cell"
          class="mgmt-table contract-invoice-table"
        >
          <el-table-column prop="shopName" label="店铺" width="64" align="center" show-overflow-tooltip class-name="merge-col text-col-20"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="76" show-overflow-tooltip class-name="merge-col"></el-table-column>
          <el-table-column prop="invoiceStatus" label="开票状态" width="72" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.invoiceStatusLabel" size="mini" :type="getInvoiceStatusType(scope.row.invoiceStatus)" effect="light">
                {{ scope.row.invoiceStatusLabel }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="132" show-overflow-tooltip class-name="text-col-20"></el-table-column>
          <el-table-column prop="specModel" label="规格型号" width="132" show-overflow-tooltip class-name="text-col-20"></el-table-column>
          <el-table-column prop="unit" label="单位" width="40" align="center">
            <template slot-scope="scope">{{ scope.row.unit || "个" }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="48" align="right"></el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="64" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="64" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.amount) }}</template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" width="48" align="right">
            <template slot-scope="scope">{{ formatTaxRate(scope.row.taxRate) }}</template>
          </el-table-column>
          <el-table-column prop="taxAmount" label="税额" width="64" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.taxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalAmount" label="金额合计" width="68" align="right" class-name="merge-col">
            <template slot-scope="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalTaxAmount" label="税费合计" width="68" align="right" class-name="merge-col">
            <template slot-scope="scope">{{ formatMoney(scope.row.totalTaxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="totalWithTax" label="价税合计" width="68" align="right" class-name="merge-col highlight-amount">
            <template slot-scope="scope">
              <span class="money-text">{{ formatMoney(scope.row.totalWithTax) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceDate" label="开票日期" width="84" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="invoiceFileUrls" label="发票" width="140" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="scope.row._invoiceImageUrls.length" class="contract-file-thumbs">
                <el-image
                  v-for="(url, index) in scope.row._invoiceImageUrls.slice(0, 3)"
                  :key="url + '-' + index"
                  :src="url"
                  :preview-src-list="scope.row._invoiceImageUrls"
                  fit="cover"
                  class="contract-file-thumb"
                ></el-image>
                <span v-if="scope.row._invoiceImageUrls.length > 3" class="contract-file-more">+{{ scope.row._invoiceImageUrls.length - 3 }}</span>
              </div>
              <el-button
                v-else-if="scope.row._invoiceFileItems.length"
                type="text"
                size="small"
                class="contract-file-link"
                @click="onPreviewInvoiceFile(scope.row)"
              >
                {{ getInvoiceFileDisplayName(scope.row) }}
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="invoiceDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="预览合同" :visible.sync="printDialogVisible" width="920px" custom-class="purchase-contract-print-dialog" :close-on-click-modal="false">
      <div class="print-config-panel" :class="{ 'print-config-readonly': !canEditPrintConfig }" v-loading="printDialogLoading">
        <div class="print-config-row">
          <div class="print-config-item">
            <span class="print-config-label">签订地点</span>
            <el-input v-model="printForm.signingLocation" size="small" clearable placeholder="默认空白" :disabled="!canEditPrintConfig"></el-input>
          </div>
          <div class="print-config-item">
            <span class="print-config-label">签订时间</span>
            <el-date-picker v-model="printForm.signingDate" size="small" type="date" value-format="yyyy-MM-dd" placeholder="最早采购日期减3天" :disabled="!canEditPrintConfig" @change="onPrintSigningDateChange"></el-date-picker>
          </div>
          <div class="print-config-item wide">
            <span class="print-config-label">交货时间</span>
            <el-date-picker v-model="deliveryDateRange" size="small" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" class="print-config-daterange" :disabled="!canEditPrintConfig"></el-date-picker>
          </div>
        </div>
        <div class="print-config-row">
          <div class="print-config-item wide">
            <span class="print-config-label">交货方式及地点</span>
            <el-input v-model="printForm.deliveryMethodLocation" size="small" clearable placeholder="杭州市拱墅区祥园路39号誉恒园" :disabled="!canEditPrintConfig"></el-input>
          </div>
        </div>
      </div>

      <div class="print-preview-wrapper">
        <div id="purchase-contract-print" class="purchase-contract-print">
          <div class="contract-title">产品购销合同</div>
          <div class="contract-meta-line">
            <span class="contract-label">合同编号：</span>
            <span class="contract-value">{{ printData.contractNo || "" }}</span>
          </div>
          <div class="contract-party-line">
            <span class="party-left">
              <span class="contract-label">供方：</span>
              <span class="contract-value">{{ printData.supplierFullName || "" }}</span>
            </span>
            <span class="party-right">
              <span class="contract-label">签订地点：</span>
              <span class="contract-value">{{ printForm.signingLocation || "" }}</span>
            </span>
          </div>
          <div class="contract-party-line">
            <span class="party-left">
              <span class="contract-label">需方：</span>
              <span class="contract-value">{{ printData.buyerName || "" }}</span>
            </span>
            <span class="party-right">
              <span class="contract-label">签订时间：</span>
              <span class="contract-value">{{ printForm.signingDate || "" }}</span>
            </span>
          </div>

          <table class="contract-table" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th class="col-name">品名</th>
                <th class="col-spec">规格型号</th>
                <th class="col-qty">数量</th>
                <th class="col-unit">单位</th>
                <th class="col-price">单价</th>
                <th class="col-total">总价（含税）</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="line in printData.lines" :key="line.index">
                <td class="col-name-cell">{{ line.projectName || "" }}</td>
                <td class="col-spec-cell">{{ line.specModel || "" }}</td>
                <td class="text-right">{{ line.quantity }}</td>
                <td class="text-center">{{ line.unit || "个" }}</td>
                <td class="text-right">{{ formatPrintNumber(line.unitPrice) }}</td>
                <td class="text-right">{{ formatPrintNumber(line.lineTotalWithTax) }}</td>
              </tr>
              <tr class="contract-total-row">
                <td colspan="2" class="text-center">
                  <span class="contract-label">合计价格（大写）</span>
                </td>
                <td colspan="3" class="text-center">{{ printTotalWithTaxUpper }}</td>
                <td class="text-right">{{ formatPrintNumber(printData.totalWithTax) }} 元</td>
              </tr>
            </tbody>
          </table>

          <div class="contract-terms-section">
            <div class="contract-term-line">
              <span class="contract-label">交货时间：</span>
              <span class="term-value">{{ printDeliveryDateText }}</span>
            </div>
            <div class="contract-term-line">
              <span class="contract-label">质量要求技术标准：</span>
              <span class="term-value">{{ printForm.qualityStandard || "" }}</span>
            </div>
            <div class="contract-term-line">
              <span class="contract-label">包装要求及费用承担：</span>
              <span class="term-value">{{ printForm.packagingRequirement || "" }}</span>
            </div>
            <div class="contract-term-line">
              <span class="contract-label">验收方式：</span>
              <span class="term-value">{{ printForm.acceptanceMethod || "" }}</span>
            </div>
            <div class="contract-term-line">
              <span class="contract-label">交货方式及地点：</span>
              <span class="term-value">{{ printForm.deliveryMethodLocation || "" }}</span>
            </div>
            <div class="contract-term-line">
              <span class="contract-label">结算方式及期限：</span>
              <span class="term-value">{{ printForm.settlementMethod || "" }}</span>
            </div>
          </div>

          <div class="contract-general-section">
            <div class="contract-general-title">
              <span class="contract-label">一般条款：</span>
            </div>
            <div class="contract-general-item">1、本合同依法签订，即具有法律效力，双方均应严格执行，任何一方不得擅自变更和解除。如一方因故需变更或解除时，应经双方协商同意，另行商议并签订新合同，否则合同仍然有效。</div>
            <div class="contract-general-item">2、供方应严格按本合同约定的质量、包装等要求如期交货，否则需方有权拒绝接受货物并要求供方赔偿由此造成的损失。</div>
            <div class="contract-general-item">3、需方应严格按本合同约定支付货款。</div>
            <div class="contract-general-item">4、如合同双方在合同履行中发生纠纷，应协商解决。</div>
          </div>

          <div class="contract-sign-row">
            <span class="contract-sign-item">
              <span class="contract-label">供方：（盖章）</span>
            </span>
            <span class="contract-sign-item">
              <span class="contract-label">需方：（盖章）</span>
            </span>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="printDialogVisible = false">关 闭</el-button>
        <el-button v-if="canEditPrintConfig" type="primary" plain @click="savePrintConfig" :loading="printSaving">保存配置</el-button>
        <el-button type="primary" v-print="'#purchase-contract-print'">打 印</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="contractFileUploadTitle"
      :visible.sync="contractFileUploadVisible"
      width="640px"
      custom-class="contract-file-upload-dialog"
      :close-on-click-modal="false"
      @opened="onContractFileUploadDialogOpened"
      @closed="onContractFileUploadDialogClosed"
    >
      <div ref="contractFilePastePanel" class="contract-file-upload-panel" tabindex="0" v-loading="contractFileUploading">
        <div class="contract-file-upload-list">
          <div v-for="(item, index) in contractFileUploadItems" :key="item.url + '-' + index" class="contract-file-upload-item">
            <el-image v-if="item.isImage" :src="item.url" fit="cover" class="contract-file-upload-image" :preview-src-list="contractFileUploadImageUrls"></el-image>
            <div v-else class="contract-file-upload-pdf">
              <i class="el-icon-document"></i>
              <span>{{ item.name || "PDF合同" }}</span>
            </div>
            <i class="el-icon-error contract-file-upload-remove" @click="removeContractFileUploadItem(index)"></i>
          </div>
          <el-upload
            class="contract-file-upload-add"
            action="/biz/oss/upload"
            name="file"
            accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.pdf,image/*,application/pdf"
            :show-file-list="false"
            :before-upload="beforeContractFileUpload"
            :on-success="handleContractFileUploadSuccess"
            :disabled="contractFileUploading"
          >
            <div class="contract-file-upload-trigger">
              <i class="el-icon-plus"></i>
              <span>添加文件</span>
            </div>
          </el-upload>
        </div>
        <div class="contract-file-upload-tip">支持 JPG、PNG、GIF、WEBP、BMP、PDF；可上传多张照片，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contractFileUploadVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveContractFileUpload" :loading="contractFileUploadSaving">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="filePreviewTitle" :visible.sync="contractFilePreviewVisible" width="860px" custom-class="contract-file-preview-dialog" :close-on-click-modal="false">
      <div class="contract-file-preview-content">
        <div v-if="contractFilePreviewImages.length || contractFilePreviewPdfUrl" class="contract-file-preview-body">
          <div v-if="contractFilePreviewImages.length" class="contract-file-preview-images">
            <el-image
              v-for="(url, index) in contractFilePreviewImages"
              :key="url + '-' + index"
              :src="url"
              :preview-src-list="contractFilePreviewImages"
              fit="contain"
              class="contract-file-preview-full"
            ></el-image>
          </div>
          <iframe v-if="contractFilePreviewPdfUrl" :src="contractFilePreviewPdfUrl" class="contract-file-preview-frame"></iframe>
        </div>
        <div v-else class="contract-file-preview-empty">{{ filePreviewEmptyText }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="contractFilePreviewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="1200px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" class="record-table">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { purchaseContractModules, invoiceModules, requestModules, ossModules } from "@r";
import {
  PAY_ORDER_SOURCE_TYPE,
  PAY_ORDER_SOURCE_TYPE_FILTER_OPTIONS,
  getPayOrderSourceTypeLabel,
} from "../../constants/payOrderStatus";

const CONTRACT_MERGE_PROPS = [
  "contractNo",
  "shopName",
  "supplierName",
  "sourceType",
  "sourceTypeLabel",
  "contractStatus",
  "totalAmount",
  "totalTaxAmount",
  "totalWithTax",
  "contractDate",
  "contractFileUrls",
  "createTime",
  "remark",
];

const INVOICE_DIALOG_MERGE_PROPS = [
  "shopName",
  "supplierName",
  "invoiceStatus",
  "totalAmount",
  "totalTaxAmount",
  "totalWithTax",
  "invoiceDate",
  "invoiceFileUrls",
];

const INVOICE_STATUS = {
  PENDING: 0,
  INVOICED: 1,
  VOID: 2,
  INFO_REVIEW: 3,
  INVOICE_REVIEW: 4,
  INFO_CONFIRM: 5,
};

const STATUS_TABS = [
  { name: "all", label: "全部", showBadge: false },
  { name: "待配置合同信息", label: "配置合同信息", showBadge: true },
  { name: "待合同信息审核", label: "合同信息审核", showBadge: true },
  { name: "待签署合同", label: "待签署合同", showBadge: true },
  { name: "待合同审核", label: "待合同审核", showBadge: true },
  { name: "已签署合同", label: "已签署合同", showBadge: false },
  { name: "已作废", label: "已作废", showBadge: false },
];

const SHOP_OPTIONS = ["灵柚", "萧发", "誉腾", "甄昂", "众联", "杭傲"];

const CONTRACT_STATUS = {
  PENDING: 0,
  SIGNED: 1,
  VOID: 2,
  INFO_REVIEW: 3,
  CONTRACT_REVIEW: 4,
  CONFIG: 5,
};

const REVIEWABLE_CONTRACT_STATUSES = [
  CONTRACT_STATUS.CONFIG,
  CONTRACT_STATUS.INFO_REVIEW,
  CONTRACT_STATUS.PENDING,
  CONTRACT_STATUS.CONTRACT_REVIEW,
];

const DEFAULT_DELIVERY_METHOD_LOCATION = "杭州市拱墅区祥园路39号誉恒园";

function amountToChineseUpper(amount) {
  let value = Math.abs(parseFloat(amount) || 0);
  if (!value) {
    return "零圆整";
  }
  const CN_NUM = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  const CN_UNIT = ["", "拾", "佰", "仟"];
  const CN_SECTION = ["", "万", "亿", "兆"];
  let integerPart = Math.floor(value + 0.000001);
  let decimalPart = Math.round((value - integerPart) * 100);
  let jiao = Math.floor(decimalPart / 10);
  let fen = decimalPart % 10;

  function sectionToChinese(section) {
    let result = "";
    let zero = false;
    for (let i = 0; i < 4 && section > 0; i++) {
      let digit = section % 10;
      if (digit === 0) {
        if (!zero && result) {
          zero = true;
        }
      } else {
        if (zero) {
          result = CN_NUM[0] + result;
          zero = false;
        }
        result = CN_NUM[digit] + CN_UNIT[i] + result;
      }
      section = Math.floor(section / 10);
    }
    return result;
  }

  let integerText = "";
  let sectionIndex = 0;
  while (integerPart > 0) {
    let section = integerPart % 10000;
    if (section) {
      integerText = sectionToChinese(section) + CN_SECTION[sectionIndex] + integerText;
    } else if (integerText) {
      integerText = CN_NUM[0] + integerText;
    }
    integerPart = Math.floor(integerPart / 10000);
    sectionIndex++;
  }
  integerText = (integerText || CN_NUM[0]) + "圆";
  if (jiao === 0 && fen === 0) {
    integerText += "整";
  } else {
    if (jiao) {
      integerText += CN_NUM[jiao] + "角";
    } else if (fen) {
      integerText += "零";
    }
    if (fen) {
      integerText += CN_NUM[fen] + "分";
    }
  }
  return integerText;
}

export default {
  data() {
    return {
      tableData: [],
      contractList: [],
      total: 0,
      currentPage: 1,
      loading: false,
      activeStatusTab: "all",
      statusTabs: STATUS_TABS,
      statusCounts: {
        待配置合同信息: 0,
        待合同信息审核: 0,
        待签署合同: 0,
        待合同审核: 0,
      },
      createDate: [],
      supplierList: [],
      shopOptions: SHOP_OPTIONS,
      sourceTypeOptions: PAY_ORDER_SOURCE_TYPE_FILTER_OPTIONS,
      params: {
        beginIndex: 0,
        pageSize: 50,
        shopName: "",
        supplierId: "",
        sourceType: "",
        contractNo: "",
      },
      screenHeight: 400,
      invoiceDialogVisible: false,
      invoiceDialogLoading: false,
      invoiceTableData: [],
      printDialogVisible: false,
      printDialogLoading: false,
      printPreviewContractStatus: null,
      printSaving: false,
      printData: {
        _id: "",
        contractNo: "",
        supplierFullName: "",
        buyerName: "",
        lines: [],
        totalWithTax: 0,
      },
      printForm: {
        signingLocation: "",
        signingDate: "",
        deliveryDateStart: "",
        deliveryDateEnd: "",
        deliveryDate: "",
        qualityStandard: "出货产品按照封货样。",
        packagingRequirement: "纸箱包装。",
        acceptanceMethod: "需方及外商检验合格。",
        deliveryMethodLocation: DEFAULT_DELIVERY_METHOD_LOCATION,
        settlementMethod: "每次按照实际出货数量进行结算。",
      },
      contractFileUploadVisible: false,
      contractFileUploadTitle: "上传合同",
      contractFileUploadSaving: false,
      contractFileUploading: false,
      contractFileUploadRow: null,
      contractFileUploadItems: [],
      contractFilePreviewVisible: false,
      contractFilePreviewImages: [],
      contractFilePreviewPdfUrl: "",
      filePreviewTitle: "合同预览",
      filePreviewEmptyText: "暂无合同文件",
      rejectDialogVisible: false,
      rejectSubmitting: false,
      rejectContractId: "",
      rejectTargetStatus: "",
      rejectReason: "",
      opreateLogVisible: false,
      operateHistory: [],
    };
  },
  computed: {
    canEditPrintConfig() {
      return this.printPreviewContractStatus === CONTRACT_STATUS.CONFIG;
    },
    printTotalWithTaxUpper() {
      return amountToChineseUpper(this.printData.totalWithTax);
    },
    printDeliveryDateText() {
      if (this.printForm.deliveryDateStart && this.printForm.deliveryDateEnd) {
        return this.printForm.deliveryDateStart + " 至 " + this.printForm.deliveryDateEnd;
      }
      return this.printForm.deliveryDate || this.printForm.deliveryDateStart || this.printForm.deliveryDateEnd || "";
    },
    deliveryDateRange: {
      get() {
        if (this.printForm.deliveryDateStart && this.printForm.deliveryDateEnd) {
          return [this.printForm.deliveryDateStart, this.printForm.deliveryDateEnd];
        }
        return [];
      },
      set(value) {
        if (value && value.length === 2) {
          this.printForm.deliveryDateStart = value[0] || "";
          this.printForm.deliveryDateEnd = value[1] || "";
          this.printForm.deliveryDate = this.printDeliveryDateText;
          return;
        }
        this.printForm.deliveryDateStart = "";
        this.printForm.deliveryDateEnd = "";
        this.printForm.deliveryDate = "";
      },
    },
    contractFileUploadImageUrls() {
      return this.contractFileUploadItems.filter(item => item.isImage).map(item => item.url);
    },
  },
  mounted() {
    this.fetchSuppliers();
    this.getData();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
    document.removeEventListener("paste", this.handleContractFilePaste);
  },
  methods: {
    fetchSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata || [];
      });
    },
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const tabs = panel.querySelector(".status-tabs");
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const tabsHeight = tabs ? tabs.offsetHeight : 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const gap = 12;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - tabsHeight - paginationHeight - gap;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    formatMoney(value) {
      if (value === "" || value === null || value === undefined) {
        return "0.00";
      }
      return parseFloat(value).toFixed(2);
    },
    formatTaxRate(value) {
      let taxRate = parseFloat(value);
      if (isNaN(taxRate)) {
        return "0%";
      }
      return (taxRate * 100).toFixed(0) + "%";
    },
    formatCreateDate(time) {
      if (!time) return "--";
      let date = new Date(Number(time));
      if (isNaN(date.getTime())) return "--";
      return date.format("yyyy-MM-dd");
    },
    formatCreateTimePart(time) {
      if (!time) return "--";
      let date = new Date(Number(time));
      if (isNaN(date.getTime())) return "--";
      return date.format("hh:mm:ss");
    },
    formatPrintNumber(value) {
      if (value === "" || value === null || value === undefined) {
        return "0";
      }
      return parseFloat(value).toString();
    },
    addDays(dateStr, days) {
      if (!dateStr) {
        return "";
      }
      let date = new Date(String(dateStr).replace(/-/g, "/") + " 00:00:00");
      if (isNaN(date.getTime())) {
        return "";
      }
      date.setDate(date.getDate() + days);
      return date.format("yyyy-MM-dd");
    },
    buildPrintFormFromData(data) {
      return {
        signingLocation: data.signingLocation || "",
        signingDate: data.signingDate || "",
        deliveryDateStart: data.deliveryDateStart || "",
        deliveryDateEnd: data.deliveryDateEnd || "",
        deliveryDate: data.deliveryDate || "",
        qualityStandard: data.qualityStandard || "出货产品按照封货样。",
        packagingRequirement: data.packagingRequirement || "纸箱包装。",
        acceptanceMethod: data.acceptanceMethod || "需方及外商检验合格。",
        deliveryMethodLocation: data.deliveryMethodLocation || DEFAULT_DELIVERY_METHOD_LOCATION,
        settlementMethod: data.settlementMethod || "每次按照实际出货数量进行结算。",
      };
    },
    onPrintSigningDateChange() {
      if (!this.canEditPrintConfig || !this.printForm.signingDate) {
        return;
      }
      this.printForm.deliveryDateStart = this.addDays(this.printForm.signingDate, 3);
      this.printForm.deliveryDateEnd = this.addDays(this.printForm.deliveryDateStart, 60);
      this.printForm.deliveryDate = this.printDeliveryDateText;
    },
    buildQueryParams() {
      let query = {
        shopName: this.params.shopName || "",
        supplierId: this.params.supplierId,
        sourceType: this.params.sourceType || "",
        contractNo: (this.params.contractNo || "").trim(),
        beginIndex: this.params.beginIndex,
        pageSize: this.params.pageSize,
        contractStatusTab: this.activeStatusTab,
      };
      if (this.createDate && this.createDate.length === 2) {
        query.beginCreateDate = this.createDate[0].format("yyyy-MM-dd");
        query.endCreateDate = this.createDate[1].format("yyyy-MM-dd");
      }
      return query;
    },
    getSourceTypeLabel(sourceType) {
      return getPayOrderSourceTypeLabel(sourceType);
    },
    getSourceTypeTagType(sourceType) {
      if (sourceType === PAY_ORDER_SOURCE_TYPE.PURCHASE_ORDER) {
        return "success";
      }
      return "info";
    },
    onStatusTabChange(tab) {
      this.activeStatusTab = tab.name;
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    getContractStatusType(contractStatus) {
      if (contractStatus === CONTRACT_STATUS.CONFIG) {
        return "info";
      }
      if (contractStatus === CONTRACT_STATUS.INFO_REVIEW) {
        return "info";
      }
      if (contractStatus === CONTRACT_STATUS.PENDING) {
        return "warning";
      }
      if (contractStatus === CONTRACT_STATUS.CONTRACT_REVIEW) {
        return "warning";
      }
      if (contractStatus === CONTRACT_STATUS.SIGNED) {
        return "success";
      }
      if (contractStatus === CONTRACT_STATUS.VOID) {
        return "info";
      }
      return "info";
    },
    canUploadContract(row) {
      return !!row._id && [CONTRACT_STATUS.PENDING, CONTRACT_STATUS.SIGNED].includes(row.contractStatus);
    },
    getUploadContractButtonLabel(row) {
      return this.getContractFileItems(row).length ? "更新合同" : "上传合同";
    },
    canReviewContract(row) {
      return !!row._id && REVIEWABLE_CONTRACT_STATUSES.includes(row.contractStatus);
    },
    canRejectContract(row) {
      return (
        !!row._id &&
        [CONTRACT_STATUS.INFO_REVIEW, CONTRACT_STATUS.PENDING, CONTRACT_STATUS.CONTRACT_REVIEW].includes(row.contractStatus)
      );
    },
    getContractPassButtonLabel(contractStatus) {
      const map = {
        [CONTRACT_STATUS.CONFIG]: "提交合同信息审核",
        [CONTRACT_STATUS.INFO_REVIEW]: "审核通过",
        [CONTRACT_STATUS.PENDING]: "提交合同审核",
        [CONTRACT_STATUS.CONTRACT_REVIEW]: "审核通过",
      };
      return map[contractStatus] || "通过";
    },
    getVisibleContractActions(row) {
      const actions = [];
      if (this.canReviewContract(row)) {
        actions.push({ key: "approve", label: this.getContractPassButtonLabel(row.contractStatus), btnClass: "success" });
      }
      if (this.canRejectContract(row)) {
        actions.push({ key: "reject", label: "打回", btnClass: "warning" });
      }
      return actions;
    },
    getMoreContractActions(row) {
      const actions = [];
      if (this.canUploadContract(row)) {
        actions.push({ key: "upload", label: this.getUploadContractButtonLabel(row), btnClass: "" });
      }
      actions.push({ key: "preview", label: "预览合同", btnClass: "" });
      actions.push({ key: "download", label: "下载", btnClass: "" });
      actions.push({ key: "viewInvoices", label: "查看发票", btnClass: "" });
      actions.push({ key: "operateLog", label: "操作记录", btnClass: "" });
      if (this.canVoidContract(row)) {
        actions.push({ key: "void", label: "作废", btnClass: "danger" });
      }
      if (this.canDeleteContract(row)) {
        actions.push({ key: "delete", label: "删除", btnClass: "danger" });
      }
      return actions;
    },
    handleContractRowAction(command, row) {
      if (command === "approve") {
        this.onApproveContract(row);
      } else if (command === "reject") {
        this.onRejectContract(row);
      } else if (command === "upload") {
        this.onUploadContractFile(row);
      } else if (command === "preview") {
        this.onPreviewContract(row);
      } else if (command === "download") {
        this.onDownloadContract(row);
      } else if (command === "viewInvoices") {
        this.onViewInvoices(row);
      } else if (command === "operateLog") {
        this.showOpreateLog(row);
      } else if (command === "void") {
        this.onVoidContract(row);
      } else if (command === "delete") {
        this.onDeleteContract(row);
      }
    },
    canVoidContract(row) {
      return (
        !!row._id &&
        [
          CONTRACT_STATUS.CONFIG,
          CONTRACT_STATUS.INFO_REVIEW,
          CONTRACT_STATUS.PENDING,
          CONTRACT_STATUS.CONTRACT_REVIEW,
          CONTRACT_STATUS.SIGNED,
        ].includes(row.contractStatus)
      );
    },
    canDeleteContract(row) {
      return !!row._id && row.contractStatus === CONTRACT_STATUS.VOID;
    },
    getData() {
      this.loading = true;
      purchaseContractModules
        .fetchPurchaseContracts(this.buildQueryParams())
        .then(res => {
          this.contractList = res.ldata || [];
          this.tableData = this.expandContractList(this.contractList);
          this.total = res.total || 0;
          if (res.mdata && res.mdata.statusCounts) {
            this.statusCounts = {
              ...this.statusCounts,
              ...res.mdata.statusCounts,
            };
          }
        })
        .catch(() => {
          this.$message.error("查询失败");
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    queryBtn() {
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    handlerPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.getData();
    },
    expandContractList(contracts) {
      let result = [];
      (contracts || []).forEach((contract, contractIndex) => {
        let lines = contract.lines && contract.lines.length ? contract.lines : [{}];
        let rowKey = contract._id || `contract-${contractIndex}`;
        let contractFileItems = this.buildContractFileItems(contract.contractFileUrls, contract.contractFileNames);
        let contractImageUrls = contractFileItems.filter(item => item.isImage).map(item => item.url);
        lines.forEach((line, index) => {
          result.push({
            _id: contract._id,
            _rowKey: rowKey,
            contractId: contract.contractId,
            contractNo: contract.contractNo || "",
            shopName: contract.shopName || "",
            supplierId: contract.supplierId,
            supplierName: contract.supplierName || "",
            sourceType: contract.sourceType || "",
            sourceTypeLabel: contract.sourceTypeLabel || "",
            contractStatus: contract.contractStatus != null ? contract.contractStatus : CONTRACT_STATUS.PENDING,
            contractStatusLabel: contract.contractStatusLabel || "",
            contractFileUrls: contract.contractFileUrls || [],
            contractFileNames: contract.contractFileNames || [],
            _contractFileItems: contractFileItems,
            _contractImageUrls: contractImageUrls,
            invoiceIds: contract.invoiceIds || [],
            totalAmount: contract.totalAmount,
            totalTaxAmount: contract.totalTaxAmount,
            totalWithTax: contract.totalWithTax,
            contractDate: contract.contractDate || "",
            createTime: contract.createTime,
            remark: contract.remark || "",
            rejectReason: contract.rejectReason || "",
            projectName: line.projectName || "",
            specModel: line.specModel || "",
            unit: line.unit || "个",
            quantity: line.quantity,
            unitPrice: line.unitPrice,
            amount: line.amount,
            taxRate: line.taxRate,
            taxAmount: line.taxAmount,
            _contractRowSpan: index === 0 ? lines.length : 0,
          });
        });
      });
      return result;
    },
    getContractRowIndex(row) {
      let contractIndex = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i]._contractRowSpan > 0) {
          contractIndex++;
          if (this.tableData[i]._rowKey === row._rowKey) {
            return this.params.beginIndex + contractIndex;
          }
        }
      }
      return "";
    },
    contractTableCellClassName({ row, column }) {
      let classNames = [];
      if (CONTRACT_MERGE_PROPS.includes(column.property)) {
        classNames.push("merge-col");
      }
      if (column.property === "totalWithTax") {
        classNames.push("highlight-amount");
      }
      if (column.label === "操作") {
        classNames.push("action-col");
      }
      return classNames.join(" ");
    },
    spanMethod({ row, column }) {
      if (CONTRACT_MERGE_PROPS.includes(column.property)) {
        let rowspan = row._contractRowSpan || 0;
        return { rowspan, colspan: rowspan > 0 ? 1 : 0 };
      }
      if (column.label === "序号" || column.label === "操作") {
        let rowspan = row._contractRowSpan || 0;
        return { rowspan, colspan: rowspan > 0 ? 1 : 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    onPreviewContract(row) {
      this.printPreviewContractStatus = row.contractStatus;
      this.printDialogVisible = true;
      this.printDialogLoading = true;
      purchaseContractModules
        .fetchPurchaseContractPrintData({ _id: row._id })
        .then(res => {
          if (res.result !== 1 || !res.ldata || !res.ldata.length) {
            this.printDialogVisible = false;
            this.$message.error(res.message || "加载合同预览失败");
            return;
          }
          let data = res.ldata[0];
          this.printPreviewContractStatus =
            data.contractStatus != null ? data.contractStatus : row.contractStatus;
          this.printData = {
            _id: data._id,
            contractNo: data.contractNo || "",
            supplierFullName: data.supplierFullName || "",
            buyerName: data.buyerName || "",
            lines: data.lines || [],
            totalWithTax: data.totalWithTax || 0,
          };
          this.printForm = this.buildPrintFormFromData(data);
        })
        .catch(() => {
          this.printDialogVisible = false;
          this.$message.error("加载合同预览失败");
        })
        .finally(() => {
          this.printDialogLoading = false;
        });
    },
    onDownloadContract(row) {
      if (!row._id) {
        return;
      }
      window.open(purchaseContractModules.getPurchaseContractWordDownloadUrl({ _id: row._id }), "_blank");
    },
    savePrintConfig() {
      if (!this.printData._id || !this.canEditPrintConfig) {
        return;
      }
      this.printSaving = true;
      let deliveryDateText = this.printDeliveryDateText;
      purchaseContractModules
        .addOrUpdatePurchaseContract({
          _id: this.printData._id,
          signingLocation: this.printForm.signingLocation || "",
          signingDate: this.printForm.signingDate || "",
          deliveryDateStart: this.printForm.deliveryDateStart || "",
          deliveryDateEnd: this.printForm.deliveryDateEnd || "",
          deliveryDate: deliveryDateText,
          deliveryMethodLocation: this.printForm.deliveryMethodLocation || DEFAULT_DELIVERY_METHOD_LOCATION,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("合同配置已保存");
        })
        .catch(() => {
          this.$message.error("保存失败");
        })
        .finally(() => {
          this.printSaving = false;
        });
    },
    getInvoiceStatusType(invoiceStatus) {
      if (invoiceStatus === INVOICE_STATUS.INFO_CONFIRM) {
        return "warning";
      }
      if (invoiceStatus === INVOICE_STATUS.INFO_REVIEW) {
        return "info";
      }
      if (invoiceStatus === INVOICE_STATUS.PENDING) {
        return "warning";
      }
      if (invoiceStatus === INVOICE_STATUS.INVOICE_REVIEW) {
        return "warning";
      }
      if (invoiceStatus === INVOICE_STATUS.INVOICED) {
        return "success";
      }
      if (invoiceStatus === INVOICE_STATUS.VOID) {
        return "info";
      }
      return "";
    },
    expandInvoiceList(invoices, fallbackShopName) {
      let result = [];
      (invoices || []).forEach((invoice, invoiceIndex) => {
        let lines = invoice.lines && invoice.lines.length ? invoice.lines : [{}];
        let rowKey = invoice._id || (invoice.paymentGroupIds || []).join("|") || `invoice-${invoiceIndex}`;
        let shopName = invoice.shopName || fallbackShopName || "";
        let files = this.resolveInvoiceFileLists(invoice);
        let invoiceFileItems = this.buildContractFileItems(files.urls, files.names);
        let invoiceImageUrls = invoiceFileItems.filter(item => item.isImage).map(item => item.url);
        lines.forEach((line, index) => {
          result.push({
            _id: invoice._id,
            _rowKey: rowKey,
            _tableRowKey: rowKey + "-" + index,
            invoiceStatus: invoice.invoiceStatus != null ? invoice.invoiceStatus : INVOICE_STATUS.INVOICED,
            invoiceStatusLabel: invoice.invoiceStatusLabel || "",
            shopName,
            supplierName: invoice.supplierName || "",
            totalAmount: invoice.totalAmount,
            totalTaxAmount: invoice.totalTaxAmount,
            totalWithTax: invoice.totalWithTax,
            invoiceDate: invoice.invoiceDate || "",
            invoiceFileUrls: files.urls,
            invoiceFileNames: files.names,
            _invoiceFileItems: invoiceFileItems,
            _invoiceImageUrls: invoiceImageUrls,
            projectName: line.projectName || "",
            specModel: line.specModel || "",
            unit: line.unit || "个",
            quantity: line.quantity,
            unitPrice: line.unitPrice,
            amount: line.amount,
            taxRate: line.taxRate,
            taxAmount: line.taxAmount,
            _invoiceRowSpan: index === 0 ? lines.length : 0,
          });
        });
      });
      return result;
    },
    invoiceDialogCellClassName({ row, column }) {
      let classNames = [];
      if (INVOICE_DIALOG_MERGE_PROPS.includes(column.property)) {
        classNames.push("merge-col");
      }
      if (column.property === "totalWithTax") {
        classNames.push("highlight-amount");
      }
      return classNames.join(" ");
    },
    invoiceDialogSpanMethod({ row, column }) {
      if (INVOICE_DIALOG_MERGE_PROPS.includes(column.property)) {
        let rowspan = row._invoiceRowSpan || 0;
        return { rowspan, colspan: rowspan > 0 ? 1 : 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    onViewInvoices(row) {
      let invoiceIds = row.invoiceIds || [];
      if (!invoiceIds.length) {
        this.$message.info("暂无关联发票");
        return;
      }
      this.invoiceDialogVisible = true;
      this.invoiceDialogLoading = true;
      this.invoiceTableData = [];
      Promise.all(invoiceIds.map(id => invoiceModules.fetchInvoice({ _id: id })))
        .then(results => {
          let invoices = results.filter(res => res.result === 1 && res.ldata && res.ldata.length).map(res => res.ldata[0]);
          this.invoiceTableData = this.expandInvoiceList(invoices, row.shopName);
          if (!this.invoiceTableData.length) {
            this.$message.info("未找到关联发票");
          }
        })
        .catch(() => {
          this.$message.error("加载关联发票失败");
          this.invoiceDialogVisible = false;
        })
        .finally(() => {
          this.invoiceDialogLoading = false;
        });
    },
    showOpreateLog(row) {
      this.operateHistory = [];
      this.opreateLogVisible = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: row.contractId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        });
    },
    onDeleteContract(row) {
      this.$confirm("确认删除该采购合同？", "提示", { type: "warning" }).then(() => {
        purchaseContractModules.deletePurchaseContract({ _id: row._id }).then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "删除失败");
            return;
          }
          this.$message.success("删除成功");
          this.getData();
        });
      });
    },
    onVoidContract(row) {
      this.$confirm("确认作废该采购合同？", "提示", { type: "warning" }).then(() => {
        purchaseContractModules.voidPurchaseContract({ _id: row._id }).then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "作废失败");
            return;
          }
          this.$message.success("作废成功");
          this.getData();
        });
      });
    },
    onApproveContract(row) {
      if (row.contractStatus === CONTRACT_STATUS.PENDING && !this.getContractFileItems(row).length) {
        this.$message.error("请先上传合同文件");
        return;
      }
      let label = this.getContractPassButtonLabel(row.contractStatus);
      this.$confirm(`确认${label}？`, "提示", { type: "warning" }).then(() => {
        this.updateContractStatusAction(row._id, "pass", `${label}成功`);
      });
    },
    onRejectContract(row) {
      const rejectTargetMap = {
        [CONTRACT_STATUS.INFO_REVIEW]: "待配置合同信息",
        [CONTRACT_STATUS.PENDING]: "待合同信息审核",
        [CONTRACT_STATUS.CONTRACT_REVIEW]: "待签署合同",
      };
      this.rejectContractId = row._id;
      this.rejectTargetStatus = rejectTargetMap[row.contractStatus] || "待签署合同";
      this.rejectReason = "";
      this.rejectDialogVisible = true;
    },
    submitRejectContract() {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.$message.error("请输入打回原因");
        return;
      }
      this.rejectSubmitting = true;
      purchaseContractModules
        .updatePurchaseContractStatus({
          _id: this.rejectContractId,
          action: "reject",
          rejectReason: this.rejectReason.trim(),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success("打回成功");
          this.rejectDialogVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "操作失败");
        })
        .finally(() => {
          this.rejectSubmitting = false;
        });
    },
    updateContractStatusAction(contractId, action, successText, extraPayload) {
      purchaseContractModules
        .updatePurchaseContractStatus({
          _id: contractId,
          action,
          ...(extraPayload || {}),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success(successText);
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "操作失败");
        });
    },
    isContractFileImage(url, fileName) {
      let target = fileName || url || "";
      if (/\.pdf(\?.*)?$/i.test(target)) {
        return false;
      }
      return /\.(jpg|jpeg|png|gif|webp|bmp)(\?.*)?$/i.test(target);
    },
    buildContractFileItems(urls, names) {
      let urlList = Array.isArray(urls) ? urls.filter(Boolean) : [];
      let nameList = Array.isArray(names) ? names : [];
      return urlList.map((url, index) => {
        let name = nameList[index] || "";
        return {
          url,
          name,
          isImage: this.isContractFileImage(url, name),
        };
      });
    },
    getContractFileItems(row) {
      if (row && Array.isArray(row._contractFileItems)) {
        return row._contractFileItems;
      }
      return this.buildContractFileItems(row && row.contractFileUrls, row && row.contractFileNames);
    },
    getContractFileDisplayName(row) {
      let items = this.getContractFileItems(row);
      if (!items.length) {
        return "-";
      }
      if (items.length > 1) {
        return `查看合同(${items.length})`;
      }
      if (items[0].name) {
        return items[0].name;
      }
      return items[0].isImage ? "预览图片" : "预览PDF";
    },
    onPreviewContractFile(row) {
      let items = this.getContractFileItems(row);
      if (!items.length) {
        this.$message.info("暂无合同文件");
        return;
      }
      this.filePreviewTitle = "合同预览";
      this.filePreviewEmptyText = "暂无合同文件";
      this.contractFilePreviewImages = items.filter(item => item.isImage).map(item => item.url);
      let pdfItem = items.find(item => !item.isImage);
      this.contractFilePreviewPdfUrl = pdfItem ? pdfItem.url : "";
      this.contractFilePreviewVisible = true;
    },
    // 兼容历史单数字段 invoiceFileUrl / invoiceFileName
    resolveInvoiceFileLists(invoice) {
      let urls = Array.isArray(invoice && invoice.invoiceFileUrls) ? invoice.invoiceFileUrls.filter(Boolean) : [];
      let names = Array.isArray(invoice && invoice.invoiceFileNames) ? [...invoice.invoiceFileNames] : [];
      if (!urls.length && invoice && invoice.invoiceFileUrl) {
        urls = [invoice.invoiceFileUrl];
        names = invoice.invoiceFileName ? [invoice.invoiceFileName] : [""];
      }
      while (names.length < urls.length) {
        names.push("");
      }
      return {
        urls,
        names: names.slice(0, urls.length),
      };
    },
    getInvoiceFileItems(row) {
      if (row && Array.isArray(row._invoiceFileItems)) {
        return row._invoiceFileItems;
      }
      let files = this.resolveInvoiceFileLists(row);
      return this.buildContractFileItems(files.urls, files.names);
    },
    getInvoiceFileDisplayName(row) {
      let items = this.getInvoiceFileItems(row);
      if (!items.length) {
        return "-";
      }
      if (items.length > 1) {
        return `查看发票(${items.length})`;
      }
      if (items[0].name) {
        return items[0].name;
      }
      return items[0].isImage ? "预览图片" : "预览PDF";
    },
    onPreviewInvoiceFile(row) {
      let items = this.getInvoiceFileItems(row);
      if (!items.length) {
        this.$message.info("暂无发票文件");
        return;
      }
      this.filePreviewTitle = "发票预览";
      this.filePreviewEmptyText = "暂无发票文件";
      this.contractFilePreviewImages = items.filter(item => item.isImage).map(item => item.url);
      let pdfItem = items.find(item => !item.isImage);
      this.contractFilePreviewPdfUrl = pdfItem ? pdfItem.url : "";
      this.contractFilePreviewVisible = true;
    },
    onUploadContractFile(row) {
      this.contractFileUploadRow = row;
      this.contractFileUploadItems = this.getContractFileItems(row).map(item => ({ ...item }));
      this.contractFileUploadTitle = this.contractFileUploadItems.length ? "更新合同" : "上传合同";
      this.contractFileUploadVisible = true;
    },
    onContractFileUploadDialogOpened() {
      document.addEventListener("paste", this.handleContractFilePaste);
      this.$nextTick(() => {
        if (this.$refs.contractFilePastePanel) {
          this.$refs.contractFilePastePanel.focus();
        }
      });
    },
    onContractFileUploadDialogClosed() {
      document.removeEventListener("paste", this.handleContractFilePaste);
      this.contractFileUploading = false;
    },
    isContractImageFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      let name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    beforeContractFileUpload(file) {
      let isImage = this.isContractImageFile(file);
      let isPdf = (file.type && file.type === "application/pdf") || /\.pdf$/i.test(file.name || "");
      if (!isImage && !isPdf) {
        this.$message.error("仅支持上传图片或 PDF 文件");
        return false;
      }
      let maxSize = 20 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message.error("文件大小不能超过 20MB");
        return false;
      }
      return true;
    },
    handleContractFilePaste(event) {
      if (!this.contractFileUploadVisible || this.contractFileUploading) {
        return;
      }
      let items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          let file = item.getAsFile();
          if (file) {
            this.uploadContractImageFile(file);
          }
          return;
        }
      }
    },
    uploadContractImageFile(file) {
      if (!this.isContractImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "purchaseContract");
      this.contractFileUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.contractFileUploadItems.push({
              url: res.objData.fileUrl,
              name: res.objData.originalFileName || file.name || "",
              isImage: true,
            });
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.contractFileUploading = false;
        });
    },
    handleContractFileUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        let url = res.objData.fileUrl;
        let name = res.objData.originalFileName || "";
        this.contractFileUploadItems.push({
          url,
          name,
          isImage: this.isContractFileImage(url, name),
        });
        return;
      }
      this.$message.error("上传失败");
    },
    removeContractFileUploadItem(index) {
      this.contractFileUploadItems.splice(index, 1);
    },
    saveContractFileUpload() {
      if (!this.contractFileUploadRow) {
        return;
      }
      if (!this.contractFileUploadItems.length) {
        this.$message.error("请先上传合同文件");
        return;
      }
      let urls = this.contractFileUploadItems.map(item => item.url);
      let names = this.contractFileUploadItems.map(item => item.name || "");
      this.contractFileUploadSaving = true;
      let hadFiles = this.getContractFileItems(this.contractFileUploadRow).length > 0;
      purchaseContractModules
        .updatePurchaseContractFile({
          _id: this.contractFileUploadRow._id,
          contractFileUrls: JSON.stringify(urls),
          contractFileNames: JSON.stringify(names),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success(hadFiles ? "合同更新成功" : "合同上传成功");
          this.contractFileUploadVisible = false;
          this.getData();
        })
        .catch(() => {
          this.$message.error("保存失败");
        })
        .finally(() => {
          this.contractFileUploadSaving = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#PurchaseContractMgmt {
  .filter-date {
    width: 240px;
  }

  .row-item {
    min-height: 16px;
    line-height: 16px;
  }

  .row-sub {
    color: #909399;
    font-size: 11px;
  }

  .contract-file-link {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .contract-file-thumbs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .contract-file-thumb {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    overflow: hidden;
  }

  .contract-file-more {
    font-size: 12px;
    color: #909399;
  }

  .el-table .text-col-20 .cell {
    max-width: 220px;
  }
}

.purchase-contract-print-dialog {
  .print-config-panel {
    margin-bottom: 12px;
    padding: 12px 14px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 8px;

    &.print-config-readonly {
      background: #f5f7fa;
    }
  }

  .print-config-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .print-config-item {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 240px;

    &.wide {
      flex: 1;
      min-width: 100%;
    }
  }

  .print-config-label {
    flex-shrink: 0;
    width: 92px;
    color: #606266;
    font-size: 13px;
    text-align: right;
  }

  .print-config-daterange {
    width: 100%;
    max-width: 320px;
  }

  .print-preview-wrapper {
    max-height: 70vh;
    overflow: auto;
    background: #eef1f6;
    padding: 16px;
    border-radius: 8px;
  }
}

#purchase-contract-print,
.purchase-contract-print {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  padding: 18mm 20mm 20mm;
  box-sizing: border-box;
  background: #fff;
  color: #000;
  font-family: SimSun, "Songti SC", "STSong", serif;
  font-size: 11pt;
  line-height: 1.65;
  letter-spacing: 0.2px;

  .contract-label {
    font-weight: 700;
  }

  .contract-value {
    font-weight: 400;
  }

  .contract-title {
    text-align: center;
    font-size: 20pt;
    font-weight: 700;
    margin: 0 0 16pt;
    letter-spacing: 3px;
    line-height: 1.4;
  }

  .contract-meta-line {
    margin-bottom: 10pt;
    font-size: 11pt;
  }

  .contract-party-line {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12pt;
    margin-bottom: 8pt;
    font-size: 11pt;

    .party-left {
      flex: 1;
      min-width: 0;
      word-break: break-all;
    }

    .party-right {
      flex-shrink: 0;
      width: 42%;
      text-align: left;
    }
  }

  .contract-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 12pt;
    font-size: 10pt;

    th,
    td {
      border: 1px solid #000;
      padding: 4pt 3pt;
      word-break: break-all;
      vertical-align: middle;
      line-height: 1.35;
    }

    th {
      text-align: center;
      font-weight: 700;
      font-size: 10pt;
      padding: 5pt 3pt;
    }

    .col-name {
      width: 24%;
    }

    .col-spec {
      width: 26%;
    }

    .col-qty {
      width: 9%;
    }

    .col-unit {
      width: 7%;
    }

    .col-price {
      width: 13%;
    }

    .col-total {
      width: 21%;
    }

    .col-name-cell,
    .col-spec-cell {
      font-size: 10pt;
      line-height: 1.35;
    }

    .text-right {
      text-align: right;
    }

    .text-center {
      text-align: center;
    }
  }

  .contract-total-row td {
    min-height: 24pt;
    font-size: 10pt;
  }

  .contract-terms-section {
    margin-top: 4pt;
    margin-bottom: 10pt;
  }

  .contract-term-line {
    display: flex;
    align-items: flex-start;
    margin-bottom: 7pt;
    font-size: 10.5pt;
    line-height: 1.7;

    .contract-label {
      flex-shrink: 0;
    }

    .term-value {
      flex: 1;
      min-width: 0;
      word-break: break-all;
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  .contract-general-section {
    margin-top: 6pt;
  }

  .contract-general-title {
    margin-bottom: 6pt;
    font-size: 10.5pt;
  }

  .contract-general-item {
    margin-bottom: 5pt;
    font-size: 10pt;
    line-height: 1.75;
    text-align: justify;
    text-justify: inter-ideograph;
  }

  .contract-sign-row {
    display: flex;
    justify-content: space-between;
    margin-top: 36pt;
    padding: 0 8pt;
    font-size: 11pt;

    .contract-sign-item {
      width: 42%;
    }
  }
}

@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
    margin: 0;
    padding: 0;
  }

  #purchase-contract-print,
  .purchase-contract-print {
    width: 210mm;
    min-height: 297mm;
    margin: 0;
    padding: 18mm 20mm 20mm;
    box-shadow: none;
    page-break-after: auto;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .purchase-contract-print .contract-table {
    page-break-inside: avoid;
  }

  .purchase-contract-print .contract-terms-section,
  .purchase-contract-print .contract-general-section {
    page-break-inside: avoid;
  }
}

.contract-file-upload-dialog {
  .contract-file-upload-panel {
    outline: none;
  }

  .contract-file-upload-panel:focus {
    outline: none;
  }

  .contract-file-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    min-height: 120px;
  }

  .contract-file-upload-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
  }

  .contract-file-upload-image {
    width: 120px;
    height: 120px;
  }

  .contract-file-upload-pdf {
    width: 120px;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px;
    box-sizing: border-box;
    background: #fafafa;
    color: #606266;
    font-size: 12px;
    text-align: center;
    word-break: break-all;

    i {
      font-size: 28px;
      color: #909399;
    }
  }

  .contract-file-upload-remove {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 18px;
    color: #f56c6c;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 50%;
  }

  .contract-file-upload-add .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
  }

  .contract-file-upload-add .el-upload:hover {
    border-color: #409eff;
  }

  .contract-file-upload-trigger {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    color: #909399;
    font-size: 12px;
    gap: 8px;

    i {
      font-size: 28px;
      color: #8c939d;
    }
  }

  .contract-file-upload-tip {
    margin-top: 12px;
    font-size: 12px;
    color: #909399;
    text-align: center;
    line-height: 1.6;
  }
}

.contract-file-preview-dialog {
  .contract-file-preview-content {
    min-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    border-radius: 8px;
    overflow: auto;
  }

  .contract-file-preview-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .contract-file-preview-images {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
  }

  .contract-file-preview-full {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
  }

  .contract-file-preview-frame {
    width: 100%;
    height: 70vh;
    border: none;
    background: #fff;
  }

  .contract-file-preview-empty {
    color: #909399;
    font-size: 14px;
  }
}

.pay-order-reject-dialog {
  .reject-dialog-tip {
    margin-bottom: 12px;
    color: #606266;
    font-size: 13px;
  }
}

.contract-invoice-dialog {
  max-width: 1320px;

  .el-dialog__body {
    padding: 16px 20px 8px;
    overflow: hidden;
  }

  .contract-invoice-table-wrap {
    overflow: hidden;
  }

  .contract-invoice-table {
    width: 100%;
  }

  .el-table .merge-col {
    vertical-align: middle;
  }

  .el-table .text-col-20 .cell {
    max-width: 132px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.remark-cell {
  line-height: 1.5;
  word-break: break-all;

  .reject-reason-text {
    margin-top: 4px;
    color: #e6a23c;
    font-size: 12px;
  }
}

.contract-action-dropdown {
  .el-dropdown-item.success {
    color: #67c23a;
  }

  .el-dropdown-item.warning {
    color: #e6a23c;
  }

  .el-dropdown-item.danger {
    color: #f56c6c;
  }
}
</style>
